import {
  MdDelete,
  MdEdit,
  MdPreview,
  MdOutlineAssessment,
} from 'react-icons/md'

export const MENU_ACTIONS = [
  {
    id: '1',
    icon: MdPreview,
    type: 'startView',
    label: 'Visualizar Visita',
  },
  {
    id: '2',
    icon: MdEdit,
    type: 'startEdit',
    label: 'Editar',
  },
  {
    id: '3',
    icon: MdDelete,
    type: 'delete',
    label: 'Excluir',
  },
]